import React from 'react';
import { Form, FormProps } from 'react-final-form';

interface SmartFormProps<T> extends FormProps<T> {}

export function SmartForm <T>(props: SmartFormProps<T>) {
  return <Form<T> {...props} />;
}
